<template>
  <div class="hmglPage">
    <div class="title">
      <p>
        <span>组态管理</span>
      </p>
    </div>
    <div class="content">
      <!--搜索-->
      <div class="searchBox">
        <div style="display: flex; width: calc(100% - 136px);">
          <div class="liBox">
            <span>画面名称</span>
            <el-input v-model="name" clearable placeholder="请输入画面名称"></el-input>
          </div>
        </div>
        <div class="liBox" style="width: 136px;margin-right: 24px">
          <el-button class="searchButton" type="primary" @click="searchFun">查询</el-button>
          <el-button class="searchButton">重置</el-button>
        </div>
      </div>
      <!--数据列表内容-->
      <div class="contain">
        <!--新增画面-->
        <el-button class="addBtn" type="primary" @click="addClick">
          <el-icon>
            <Plus/>
          </el-icon>
          新增画面
        </el-button>
        <!--列表-->
        <el-table v-loading="loading" :data="tableData" style="width: 100%;" table-layout="fixed">
          <template #empty>
            <el-empty class="emptyClass" description="暂无数据信息"
                      image="https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/emptyImg.png">
              <p>您可以在此页面新建画面信息</p>
            </el-empty>
          </template>
          <el-table-column fixed label="画面id" prop="stageId"></el-table-column>
          <el-table-column label="画面名称" prop="stageName"></el-table-column>
          <el-table-column align="center" label="画面缩略图" prop="stageBase64">
            <template #default="scope">
              <img :src="scope.row.stageBase64" style="width:100px"/>
            </template>
          </el-table-column>

          <el-table-column align="center" label="创建时间" prop="createTime">
            <template #default="scope">
              <span>{{ scope.row.createTime }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="315px">
            <template #default="scope">
              <div class="opacity">
                <p class="btn" @click="addClick(scope.row)">修改基础信息</p>
                <p class="btn" @click="editStage(scope.row)">编辑画面</p>
                <p class="btn" @click="monitoringStage(scope.row)">实时监控</p>
                <p class="btn" @click="delClick(scope.row)">删除</p>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pag">
          <el-pagination v-show="tableData.length > 0" v-model:page-size="pageSize" :page-sizes="[10, 20, 50, 100]"
                         :total="total" background
                         layout="total,sizes,prev, pager, next" @size-change="handleSizeChange"
                         @current-change="pageChange"/>
        </div>
      </div>
    </div>

    <!--弹窗-->
    <el-dialog v-model="dialogFormVisible" :close-on-click-modal="false" title="新增画面"
               width="40%">
      <el-form v-model="formData">
        <el-form-item label="画面名称" prop="stageName">
          <el-input v-model="formData.stageName" placeholder="请输入画面名称"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
      <span class="dialog-footer">
        <el-button class="cancle resetButton" @click="dialogFormVisible=false">取消</el-button>
        <el-button class="confrim" type="primary" @click="saveFun()">保存</el-button>
      </span>
      </template>
    </el-dialog>


    <!--    <iframe class="iframeBox" frameborder="0"-->
    <!--            src="/iframe/#/neuron/south-driver"-->
    <!--            style="width: 100%;height: 100%;"></iframe>-->

  </div>
</template>

<script setup>
//这里可以导入其他文件(比如:组件,工具js,第三方插件js,json文件,图片文件等等)
//例如:import 《组件名称》 from '《组件路径》';

import {h, onMounted, ref} from "vue";
import {ElMessage, ElMessageBox} from "element-plus";
import {addData, delData, getZtTree, listData, selectStageById, updateData} from "@/api/modules/hmgl";
import {useRouter} from "vue-router/dist/vue-router";
import {Plus} from '@element-plus/icons-vue'

let router = useRouter()

// 告警列表-----------------------------------------------------------------
// 分页
let pageNumber = ref(1)
let pageSize = ref(20)
let total = ref()
// 更改每页多少
const handleSizeChange = function (e) {
  pageSize.value = e
  getListFun()
}
// 跳转到某页
const pageChange = function (e) {
  pageNumber.value = e
  getListFun()
}
// 搜索条件
let name = ref()
// 参数表格数据
let tableData = ref([])
// 获取告警列表
let loading = ref(false)
const getListFun = function () {
  loading.value = true
  listData({
    pageNum: pageNumber.value,
    pageSize: pageSize.value,
    stageName: name.value,
  }).then(res => {
    loading.value = false
    if (res.data.code === 200) {
      console.log(res.data)
      tableData.value = res.data.rows
      total.value = Number(res.data.total)
    } else {
      ElMessage({
        message: res.data.msg,
        type: 'error'
      })
    }
  }).catch(err => {
    console.log(err);
  })
}
// 查询
const searchFun = function () {
  pageNumber.value = 1
  getListFun()
}


// 新增画面-----------------------------------------
let formData = ref({
  stageName: '',
  // stageId: null
})
// 新增弹窗
let dialogFormVisible = ref(false)
// 点击新增
const addClick = function (row) {
  dialogFormVisible.value = true
  if (row.stageId) {
    selectStageById(row.stageId).then(res => {
      if (res.data.code === 200) {
        formData.value = res.data.data;
      } else {
        ElMessage({
          message: res.data.msg,
          type: 'error'
        })
      }
    }).catch(err => {
      console.log(err);
    });
  } else {
    formData.value = {
      stageName: '',
      // stageId: null
    }
  }
  console.log(formData.value)
}
// 新增提交
const saveFun = function () {
  if (formData.value.stageId) {
    updateData(formData.value).then(response => {
      if (response.data.code === 200) {
        dialogFormVisible.value = false
        getListFun();
      } else {
        ElMessage({
          message: response.data.msg,
          type: 'error'
        })
      }
    }).catch(err => {
      console.log(err);
    });
  } else {
    addData(formData.value).then(response => {
      if (response.data.code === 200) {
        getListFun();
        dialogFormVisible.value = false
        router.push({
          path: '/admin/byzt/hmbj/' + response.data.data.stageId,
          query: {stageName: response.data.data.stageName}
        });
      } else {
        ElMessage({
          message: response.data.msg,
          type: 'error'
        })
      }
    }).catch(err => {
      console.log(err);
    });
  }
}


// 点击删除
const delClick = function (row) {
  ElMessageBox.confirm('', '', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    title: '删除画面',
    message: h('p', null, [
      h('img', {
        src: 'https://zkfiles.oss-cn-beijing.aliyuncs.com/zkepC3.0/info.png',
        style: 'width:20px;height:20px;transform: translateY(4px);margin-right:8px;'
      }, ''),
      h('span', {style: 'color:#595959;'}, '请确认是否要删除此画面，删除后数据不可恢复'),
    ])
  }).then(() => {
    delData(row.stageId).then(res => {
      if (res.data.code === 200) {
        getListFun()
        ElMessage({
          type: 'success',
          message: '删除成功'
        });
      } else {
        ElMessage({
          type: 'error',
          message: res.data.message
        })
      }
    }).catch(err => {
      console.log(err);
    })
  }).catch(() => {
    ElMessage({
      type: 'info',
      message: '已取消删除'
    });
  });
}


// 编辑画面
const editStage = function (row) {
  // router.push({path: '/admin/byzt/hmbj/' + row.stageId, query: {stageName: row.stageName}});
  //open('/static/byzt/index_edit.html?stageId='+row.stageId+"&token="+this.token);
  window.open(`#/admin/byzt/hmbj/${row.stageId}?stageName=${row.stageName}`, '_blank');
}


// 查看实时画面
const monitoringStage = function (row) {
  // router.push({path: '/admin/byzt/hmjk/' + row.stageId, query: {stageName: row.stageName}});
  window.open(`#/byzt/hmjk/${row.stageId}?stageName=${row.stageName}`, '_blank');
  //open('/static/byzt/client_view.html?stageId='+row.stageId+"&token="+this.token);
}

onMounted(() => {
  getListFun()
  getZtTree().then(res => {
    if (res.data.code === 0) {
      window.localStorage.setItem('projectTree', JSON.stringify(res.data.result))
    } else {
      ElMessage({
        type: 'error',
        message: res.data.message
      })
    }
  }).catch(err => {
    console.log(err);
  })


  // nextTick(() => {
  //   const iframe = document.querySelector(".iframeBox")
  //   console.log(iframe)
  //   iframe.onload = () => {
  //     const targetContent = iframe.contentDocument.querySelector('.el-main')
  //     iframe.contentDocument.body.innerHTML = ''
  //     iframe.contentDocument.body.appendChild(targetContent.cloneNode(true))
  //   }
  // })
})


</script>

<style lang="less">
.hmglPage {
  width: 100%;
  height: 100%;


  //标题
  .title {
    width: calc(100% - 36px);
    height: 48px;
    padding-left: 36px;
    line-height: 48px;
    //background-color: #fff;
    /* span {
       color: rgba(0, 0, 0, 0.45);
     }*/
  }

  //内容
  .content {
    width: calc(100% - 56px);
    height: calc(100% - 80px);
    padding: 0 28px 16px 28px;
    overflow: auto;

    //搜索
    .searchBox {
      margin-bottom: 16px;
      padding: 24px;
      width: calc(100% - 48px);
      background-color: #fff;
      display: flex;
      justify-content: space-between;
      flex-wrap: nowrap;
      border-radius: 6px;
      box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.09);

      .liBox {
        //margin-bottom: 16px;
        margin-right: 24px;
        display: flex;
        align-items: center;

        > p {
          margin-bottom: 8px;
        }

        > span {
          margin-right: 8px;
        }

        .el-select, .el-input {
          width: 220px;
        }
      }
    }

    //列表内容
    .contain {
      width: calc(100% - 48px);
      padding: 24px;
      background-color: #fff;
      border-radius: 6px;
      box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.09);


      //新增
      .addBtn {
        font-weight: 400;
        margin-bottom: 16px;

        .el-icon {
          margin-right: 5px;
        }
      }


      //表格
      .el-table {
        color: rgba(3, 10, 26, 0.85);

        .el-table__body-header, .el-table__header {
          th {
            background-color: rgb(250, 250, 250);
            font-weight: 500;
          }

          th:nth-child(2)::before, th:nth-child(3)::before, th:nth-child(4)::before, th:nth-child(5)::before, th:nth-child(6)::before, th:nth-child(7)::before {
            content: '';
            width: 1px;
            height: 1.6em;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            background-color: rgba(0, 0, 0, 0.06);
          }
        }

        th, td {
          padding: 0;
        }

        .cell {
          padding: 14px 16px;

          .btn {
            display: inline-block;
            color: #165DFF;
            margin-right: 14px;
            cursor: pointer;
          }


          .cont {
            display: -webkit-box; //对象作为弹性伸缩盒子模型显示
            overflow: hidden; //溢出隐藏
            -webkit-box-orient: vertical; //设置伸缩盒子对象的子元素的排列方式
            -webkit-line-clamp: 1; //设置 块元素包含的文本行数
            cursor: pointer;
          }
        }
      }

      //分页
      .pag {
        width: 100%;
        height: 32px;
        padding: 16px 0 0 0;

        .el-pagination {
          float: right;
          margin-right: 12px;
        }
      }
    }
  }

  //弹窗
  .el-dialog {


  }
}
</style>
